<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div  class="justify-content-center mt-3">
      <b-row>

        <b-col class="text-center justify-content-center" style="display: flex;">
          <div  style="width: 80%">
            <b-row>
              <b-col cols="5">
                <div class="mt-2" style="display: inline-flex; margin-top: 4px;">
                  <span style="font-size: 12px;">Total de inversión: </span>
                  <span style="font-size: 12px; font-weight: 500; color: #0069A9 "> {{ totalInversion | monedaEntero }} </span>
                </div>
              </b-col>
              <b-col cols="5">
                <div style="display: inline-flex;">
                  <span style="font-size: 12px; margin-top: 12px; margin-right: 8px;">Total a pagar: </span>
                  <b-form-input
                      :disabled="calculando"
                      v-model="montoPagar"
                      style="width: 46%"
                      type="number"
                      min="1"
                      placeholder="$0"
                      @keydown="filterJustNumber($event)"
                      @keyup.enter="calcularMontosPlazoFijo()"
                  />
                </div>
              </b-col>
                <b-col cols="2" style="display: contents">
                  <em v-if="!calculando"
                      class="calculadora"
                      @click="calcularMontosPlazoFijo()"
                      v-b-tooltip.hover.righttop.v-light
                      title="Calcular"
                  ></em>
                  <em v-if="calculando"
                      style="width: 24px"
                      class="editarV5"
                      @click="calculando = false; montoPagar = 0; costoMsiTdc = []"
                      v-b-tooltip.hover.righttop.v-light
                      title="Editar"
                  ></em>
                </b-col>

            </b-row>
          </div>

        </b-col>
      </b-row>

      <div class="justify-content-center mt-4" style="display: flex;">
        <div style="width: 80%">
          <div class="contenedorTablaSinColor text-center m-2 " style="border-radius: 10px;">
            <b-table
              responsive
              id="tablaTDC"
              thead-tr-class="columnasTablaSinColor"
              :items="costoMsiTdc"
              :fields="fields"
              selectable
              class="parrafos"
              fixed
              hover>
              <template #cell(pagoMensual)="row">
                <span >{{row.item.pagoMensual | monedaEntero}}</span>
              </template>
              <template #cell(costoFinanciamiento)="row">
                <span v-if="row.item.costoFinanciamiento !== 'Sin costo'">{{row.item.costoFinanciamiento | monedaDecimales}}</span>
                <span v-else style="color: #3EBF90; font-weight: 500">{{ row.item.costoFinanciamiento }}</span>
              </template>
              <template #cell(total)="row">
                <span >{{row.item.total | monedaDecimales}}</span>
              </template>
          </b-table>

            <span style="font-size: 10px; font-weight: 500; color: #EB6228" v-if="configuracionesMsi.length === 0"
            > La clínica no tiene configuraciones de plazos fijos </span>

            <span style="font-size: 10px; font-weight: 500; color: #0069A9" v-else-if="costoMsiTdc.length === 0"
            > Por favor ingrese el "total a pagar" seguido de un enter (↵) </span>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "TarjetaDeCreditoPF",
  props: {
    totalInversion: Number,
    idPaciente: Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    montoPagar: 0,
    costoMsiTdc: [],
    configuracionesMsi: [],
    fields: [
      {key: "meses", label: "Plazo"},
      {key: "pagoMensual", label: "Pago Mensual (aprox)"},
      {key: "costoFinanciamiento", label: "Costo de Financiamiento (iva incluido)"},
      {key: "total", label: "Total"}
    ],
    calculando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerConfiguracionPlazos();
  },
  methods:{
    calcularMontosPlazoFijo(){
      this.costoMsiTdc = [];


      if (this.totalInversion < this.montoPagar){
        this.$bvToast.toast('Su total de inversion es ' + new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(
            this.totalInversion  ), {
          title: '¡El monto es mayor!' ,
          variant: 'danger',
          solid: false
        })

      } else if(this.montoPagar === 0){
        this.$bvToast.toast( "ingrese un monto válido" , {
          title: 'Su monto es cero' ,
          variant: 'warning',
          solid: false
        })

      } else{
        this.calculando = true;
        this.configuracionesMsi.forEach(item => {
          if (item.estatusMsi || item.aplicaCostoFinanciamiento) {
            let calculo = [];
            let financSinIva = 0;
            let totalFinanMasIVA = 0;
            let costoFinanciamiento = 0;
            let montoFinal = 0;

            if (this.montoPagar <  item.montoMinimoMsi && !item.aplicaCostoFinanciamiento){
              return;
            }


            if ((this.montoPagar >= item.montoMinimoMsi && item.estatusMsi) || !item.aplicaCostoFinanciamiento) {
              calculo.meses = item.meses
              calculo.pagoMensual = Math.ceil(this.montoPagar / item.meses)
              calculo.costoFinanciamiento = 'Sin costo'
              calculo.total = this.montoPagar
            } else {
              calculo.meses = item.meses
              financSinIva = this.montoPagar * (item.porcentajeFinanciamiento / 100)
              //totalFinanMasIVA = financSinIva * 0.16                     // Es el dato de financiamiento más el iva (según lo explicado en el excel de Pablo)
              totalFinanMasIVA = Math.ceil(financSinIva) * Number(0.16);
              let ivaTruncado = this.truncarIva(totalFinanMasIVA, 2);
              costoFinanciamiento = Number(Math.ceil(financSinIva)) + ivaTruncado
              montoFinal = Number(costoFinanciamiento) + Number(this.montoPagar);

              calculo.pagoMensual = Math.ceil(montoFinal / item.meses)
              calculo.costoFinanciamiento = costoFinanciamiento
              calculo.total = montoFinal
            }


            this.costoMsiTdc.push(calculo);
          }

        })
      }



    },
    truncarIva(x, posiciones){
      var s = x.toString()
      var l = s.length
      var decimalLength = s.indexOf('.') + l
      var numStr = s.substring(0, decimalLength + posiciones)
      return Number(numStr)
    },
    obtenerConfiguracionPlazos() {
      const params = { idClinica: this.$localStorageService.getIdClinica() }
        this.$http.post(this.$api + "plazoFijo/obtenerDetalleMsi", params).then(response => {
            if (response.data.data) {
              this.configuracionesMsi = response.data.data;

              this.configuracionesMsi = this.configuracionesMsi.filter(msi => msi.registroActivo)
            }
          }
        )
    },
    filterJustNumber(e){
      const key = e.key;

      if (key === '-'){
        return e.preventDefault();
      }

      if (key === '+'){
        return e.preventDefault();
      }

      if (key === '.'){
        return e.preventDefault();
      }

      // OPTIONAL
      // If is 'e' key, stop it
      if (key === 'e'){
        return e.preventDefault();
      }

    },
  }
}
</script>
<style scoped>

</style>
